import {
  ADD_REGULATORY_BODY_REPORTING_CATEGORY,
  ADD_REGULATORY_BODY_REPORTING_CATEGORY_COMPLETED,
  ADD_REGULATORY_BODY_REPORTING_CATEGORY_FAILED,
  DELETE_REGULATORY_BODY_REPORTING_CATEGORY,
  DELETE_REGULATORY_BODY_REPORTING_CATEGORY_COMPLETED,
  DELETE_REGULATORY_BODY_REPORTING_CATEGORY_FAILED,
  GET_REGULATORY_BODY_REPORTING_CATEGORIES,
  GET_REGULATORY_BODY_REPORTING_CATEGORIES_COMPLETED,
  GET_REGULATORY_BODY_REPORTING_CATEGORIES_FAILED,
  GET_REGULATORY_BODY_REPORTING_CATEGORY,
  GET_REGULATORY_BODY_REPORTING_CATEGORY_COMPLETED,
  GET_REGULATORY_BODY_REPORTING_CATEGORY_FAILED,
  HIDE_DELETE_REGULATORY_BODY_REPORTING_CATEGORY_MODAL,
  SHOW_DELETE_REGULATORY_BODY_REPORTING_CATEGORY_MODAL,
  UPDATE_REGULATORY_BODY_REPORTING_CATEGORY,
  UPDATE_REGULATORY_BODY_REPORTING_CATEGORY_COMPLETED,
  UPDATE_REGULATORY_BODY_REPORTING_CATEGORY_FAILED,
} from "./actions";
import {AUTH_LOGOUT} from "../../Auth/actions";

const defaultState = {
  regulatoryBodyReportingCategories: [],
  regulatoryBodyReportingCategoriesLoading: false,
  regulatoryBodyReportingCategoriesError: null,
  regulatoryBodyReportingCategory: null,
  regulatoryBodyReportingCategoryLoading: false,
  regulatoryBodyReportingCategoryError: null,
  addingRegulatoryBodyReportingCategory: false,
  updatingRegulatoryBodyReportingCategory: false,
  deleteRegulatoryBodyReportingCategoryModalVisible: false,
  regulatoryBodyReportingCategoryDeleting: false,
};

const regulatoryBodyReportingCategoryReducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case GET_REGULATORY_BODY_REPORTING_CATEGORIES: {
      return {
        ...state,
        regulatoryBodyReportingCategoriesLoading: true,
        regulatoryBodyReportingCategories: [],
        regulatoryBodyReportingCategoriesError: null,
      };
    }
    case GET_REGULATORY_BODY_REPORTING_CATEGORIES_COMPLETED: {
      return {
        ...state,
        regulatoryBodyReportingCategoriesLoading: false,
        regulatoryBodyReportingCategories: action.payload.data,
      };
    }
    case GET_REGULATORY_BODY_REPORTING_CATEGORIES_FAILED: {
      return {
        ...state,
        regulatoryBodyReportingCategoriesLoading: false,
        regulatoryBodyReportingCategoriesError: action.payload,
      };
    }
    case GET_REGULATORY_BODY_REPORTING_CATEGORY: {
      return {
        ...state,
        regulatoryBodyReportingCategoryLoading: true,
        regulatoryBodyReportingCategory: null,
        regulatoryBodyReportingCategoryError: null,
      };
    }
    case GET_REGULATORY_BODY_REPORTING_CATEGORY_COMPLETED: {
      return {
        ...state,
        regulatoryBodyReportingCategoryLoading: false,
        regulatoryBodyReportingCategory: action.payload,
      };
    }
    case GET_REGULATORY_BODY_REPORTING_CATEGORY_FAILED: {
      return {
        ...state,
        regulatoryBodyReportingCategoryLoading: false,
        regulatoryBodyReportingCategoryError: action.payload,
      };
    }
    case ADD_REGULATORY_BODY_REPORTING_CATEGORY: {
      return {
        ...state,
        addingRegulatoryBodyReportingCategory: true,
      };
    }
    case ADD_REGULATORY_BODY_REPORTING_CATEGORY_COMPLETED: {
      return {
        ...state,
        addingRegulatoryBodyReportingCategory: false,
      };
    }
    case ADD_REGULATORY_BODY_REPORTING_CATEGORY_FAILED: {
      return {
        ...state,
        addingRegulatoryBodyReportingCategory: false,
      };
    }
    case UPDATE_REGULATORY_BODY_REPORTING_CATEGORY: {
      return {
        ...state,
        updatingRegulatoryBodyReportingCategory: true,
      };
    }
    case UPDATE_REGULATORY_BODY_REPORTING_CATEGORY_COMPLETED: {
      return {
        ...state,
        updatingRegulatoryBodyReportingCategory: false,
      };
    }
    case UPDATE_REGULATORY_BODY_REPORTING_CATEGORY_FAILED: {
      return {
        ...state,
        updatingRegulatoryBodyReportingCategory: false,
      };
    }
    case SHOW_DELETE_REGULATORY_BODY_REPORTING_CATEGORY_MODAL: {
      return {
        ...state,
        deleteRegulatoryBodyReportingCategoryModalVisible: true,
        regulatoryBodyReportingCategoryToDelete: action.payload,
      };
    }
    case HIDE_DELETE_REGULATORY_BODY_REPORTING_CATEGORY_MODAL: {
      return {
        ...state,
        deleteRegulatoryBodyReportingCategoryModalVisible: false,
        regulatoryBodyReportingCategoryToDelete: null,
      };
    }
    case DELETE_REGULATORY_BODY_REPORTING_CATEGORY: {
      return {
        ...state,
        regulatoryBodyReportingCategoryDeleting: true,
      };
    }
    case DELETE_REGULATORY_BODY_REPORTING_CATEGORY_COMPLETED: {
      return {
        ...state,
        regulatoryBodyReportingCategoryDeleting: false,
      };
    }
    case DELETE_REGULATORY_BODY_REPORTING_CATEGORY_FAILED: {
      return {
        ...state,
        regulatoryBodyReportingCategoryDeleting: false,
      };
    }
    case AUTH_LOGOUT: {
      return defaultState;
    }
    default:
      return state;
  }
};

export default regulatoryBodyReportingCategoryReducer;



// WEBPACK FOOTER //
// ./src/RegulatoryBody/ReportingCategory/reducer.js